export const BATCH_WORKSPACE = 'Batch Workspace';
